import { QueryClient } from "@tanstack/react-query";

export const makeQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: 30 * 60 * 1000, //30min
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          if (
            error.code === "ErrNotFound" ||
            error.code === "ErrInvalidRequest" ||
            error.group === "VALIDATION_ERROR" ||
            error.group === "DATA_CONFLICT_ERROR"
          ) {
            return false;
          }
          return failureCount < 3;
        },
        retryDelay: 1.5 * 1000, // 1.5sec
        staleTime: 60 * 1000, // 60sec
      },
    },
  });
